function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, ".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FF4141;} .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#6BBE66;} .st2{fill:#262626;}");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M27.28,29.09c13.98,0,25.31,11.33,25.31,25.31c0,13.98-11.33,25.31-25.31,25.31 C13.3,79.7,1.97,68.37,1.97,54.4C1.97,40.42,13.3,29.09,27.28,29.09L27.28,29.09L27.28,29.09z M16.08,55.07 c0.34-1.97,2.59-3.06,4.36-2c0.16,0.1,0.31,0.21,0.46,0.34l0.01,0.01c0.8,0.76,1.69,1.56,2.57,2.34l0.76,0.68l9-9.44 c0.54-0.56,0.93-0.93,1.74-1.11c2.76-0.61,4.7,2.76,2.74,4.83L26.51,62.5c-1.06,1.13-2.94,1.23-4.08,0.15 c-0.65-0.6-1.36-1.22-2.07-1.84c-1.24-1.08-2.5-2.18-3.53-3.26C16.2,56.93,15.94,55.92,16.08,55.07L16.08,55.07L16.08,55.07z"
}));

var SvgYes = function SvgYes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 29 55 47",
    style: {
      enableBackground: "new 0 0 122.88 79.71"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yes.29887093.svg";
export { ForwardRef as ReactComponent };